import React from 'react';

const AdminReports = () => {
  return (
    <div className="fade-in">
      <div className="breadcrumb">
        <a href="/admin" className="breadcrumb-item">Dashboard</a>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-item">Outils</span>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-item">Rapports</span>
      </div>

      <div className="page-header">
        <h1 className="page-title">Rapports et Analytiques</h1>
        <p className="page-subtitle">
          Consulter les rapports de performance et les statistiques
        </p>
      </div>

      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">Rapports Disponibles</h3>
          <div className="table-actions">
            <button className="btn btn-secondary">Générer Rapport</button>
          </div>
        </div>
        <div className="p-6">
          <p className="text-gray-500">Page en cours de développement...</p>
        </div>
      </div>
    </div>
  );
};

export default AdminReports;

